import { Route, Routes, Navigate } from "react-router-dom";
import { routesApp } from "./interfaces";
import { HomeLayout } from "../layout/home/home.layout";
import { ContainerLayout } from "../layout/container-layout/container-layout.layout";
import { TermsConditions } from "../components/terms-and-conditions/terms-and-conditions";
import { PolicyPrivacy } from "../components/policy-privacy/policy-privacy.component";

export const AppRouter = () => {
  const routes = [
    {
      path: routesApp?.root,
      element: <HomeLayout />,
    },

    {
      path: routesApp?.terms_conditions,
      element: (
        <ContainerLayout>
          <TermsConditions />
        </ContainerLayout>
      ),
    },
    {
      path: routesApp?.privacy,
      element: (
        <ContainerLayout>
          <PolicyPrivacy />
        </ContainerLayout>
      ),
    },
  ];

  return (
    <Routes>
      {routes.map(({ path, element }) => (
        <Route key={path} path={path} element={element} />
      ))}
      <Route
        path={routesApp?.error404}
        element={<Navigate to={routesApp?.root} />}
      />
    </Routes>
  );
};
